import { useAppSelector } from 'app/hooks';
import { isEpOnlySystemPreference } from 'utils/project';

// Reactive twin of useIsDuctedPathway for the EP-only (Electrical-Panel-
// only) existing-equipment flows: on the ductless pathway only the
// electrical panel applies. Hybrid is not EP-only — existing ducted
// equipment is optional there. STRICT on purpose: an unset/empty
// preference is NOT EP-only (prior regression lesson — never treat unset
// as a committed pathway). The rule itself is single-sourced in
// isEpOnlySystemPreference (which also handles a future multi-select
// preference).
export default function useIsEpOnlyPathway(): boolean {
  return useAppSelector((state) =>
    isEpOnlySystemPreference(
      state.project.projectSettings.find(
        (ps) => ps.code === 'system_preference'
      )?.value
    )
  );
}
